import { REQUEST, RECEIVE, SELECT } from '../types/fachgebiete'
import config from '../config'
import { isExpired } from '../utils/Utils'

function doFetch(dispatch) {
    dispatch({type: REQUEST})
    return fetch(config.baseUrl+'/api/biwe/v1/fachgebiete')
        .then(result => result.json())
        .then(
            data => {
                dispatch({
                    type: RECEIVE,
                    data
                })
            }
        )
}

function shouldFetchFachgebiete(currentState)
{
    if (currentState.isFetching) {
        return false
    }

    if (isExpired(currentState.timestamp, 10)) {
        return true
    }

    return currentState.list.length <= 0;
}

export function fetchFachgebiete() {
    return (dispatch, getState) => {
        let currentState = getState().fachgebiete
        if (shouldFetchFachgebiete(currentState)) {
            return doFetch(dispatch)
        }
    }
}

export function selectFachgebiet(id) {
    return {
        type: SELECT,
        id
    }
}


// WEBPACK FOOTER //
// ./src/actions/fachgebiete.js